import { Moment } from 'moment-timezone'
import React from 'react'
import ActiveUntilTooltip from 'src/components/ActiveUntilTooltip/ActiveUntilTooltip'
import Box from 'src/components/Box/Box'
import RadioItems from 'src/components/RadioItems/RadioItems'
import SingleDateInputField from 'src/components/SingleDateInputField/SingleDateInputField'
import Trns from 'src/localization/Trns'
import { FormProps } from 'src/types'

interface ForeverOrActiveUntilBoxProps {
  className?: string
  foreverUntilProps: {
    isForever: boolean
    setIsForever: (val: boolean) => void
  }
  validToMomentProps: FormProps<Moment | undefined>
}

const ForeverOrActiveUntilBox: React.FC<ForeverOrActiveUntilBoxProps> = (
  props,
): React.ReactElement => {
  return (
    <Box>
      <RadioItems
        fieldLabel={<Trns source={'Active Until'} />}
        id={'activeUntil'}
        noBorder
        staticOnHover
        centered
        tooltip={<ActiveUntilTooltip openLeft={false} isBudget />}
        items={[
          <SingleDateInputField
            key={0}
            showUpdates={props.validToMomentProps.showUpdates}
            baseValue={props.validToMomentProps.baseValue}
            errors={props.validToMomentProps.errors}
            dateMoment={props.validToMomentProps.value}
            onDateMomentChange={props.validToMomentProps.onChange}
          />,
          <span key={1}>
            <Trns source={'Never Ends'} />
          </span>,
        ]}
        currentIndex={props.foreverUntilProps.isForever ? 1 : 0}
        setIndex={(val: number): void => {
          props.foreverUntilProps?.setIsForever(val !== 0)
        }}
      />
    </Box>
  )
}

export default ForeverOrActiveUntilBox
